import React from 'react'
import { Route, Link } from "react-router-dom"
import Information from '../pages/account/information/Information'
import Password from '../pages/account/password/Password'
import Subscription from '../pages/account/subscription/Subscription'
import customRequest from '../helpers/customRequest'
import BeatLoader from 'react-spinners/BeatLoader'

class Account extends React.Component
{
    state = {
        username: null,
        info: null,
        loading: true
    }

    updateInfo = () => {
        customRequest.get('/api/account/info')
        .then(({data: info}) => {
            if (info.valid !== false) {
                this.setState({info: info, loading: false})
            }
        })
    }

    componentDidMount() {
        if (this.props.location?.state?.info) {
            this.setState({info: this.props.location.state.info}, () => {
                this.updateInfo()
            })
        }
        else {
            this.updateInfo()
        }
        
    }

    render() {
        var { type } = this.props
        return (
            <React.Fragment>
                {this.state.info?.verifiedEmail == false ?
                <div class="alert alert-danger">
                    You haven't yet verified your email address, and will not have access to manage sharing your subscription to other users until you do. If you'd like us to resend your verification link, please press <Link to="/account/verify-email-address/resend">this link</Link>.
                </div> : ""}

                <h1>{this.state.info?.username}</h1>
                <div class = "row subheader-text">
                    <div class = "col-sm-6 col-md-4">
                        <Link to = {{
                            pathname: "/account/information",
                            state: { info: this.state.info }
                        }} class = {`btn btn-secondary btn-lg ${type == "information" ? "active" : ""}`}>Information</Link>
                    </div>
                    
                    <div class = "col-sm-6 col-md-4">
                        <Link to = {{
                            pathname: "/account/password",
                            state: { info: this.state.info }
                        }} class = {`btn btn-secondary btn-lg ${type == "password" ? "active" : ""}`}>Password</Link>
                    </div>
                    
                    <div class = "col-sm-6 offset-sm-3 col-md-4 offset-md-0">
                        <Link to = {{
                                pathname: "/account/subscription",
                                state: { info: this.state.info }
                            }} class = {`btn btn-secondary btn-lg ${type == "subscription" ? "active" : ""} `}>Subscription
                            {/* If soon to expire */}
                            {/* <span class = "glyphicon glyphicon-alert"></span> */}
                            {/* If expired */}
                            {/* <span class = "glyphicon glyphicon-remove"></span> */}
                        </Link>
                    </div>
                </div>
                {
                    

                    <Route exact path = "/account/information"  render={(props) => {

                        return this.state.loading ? 
                                 <BeatLoader
                                        size={10}
                                        color={"#123abc"}
                                        loading={true} />
                                            
                                :
                                <Information {...props} info = {this.state.info} updateInfo = {this.updateInfo} />
                        }
                    }/>

                    
                }

                <Route exact path = "/account/password"     component = {Password} />
                <Route exact path = "/account/subscription" component = {Subscription} />
            </React.Fragment>
        )
    }
}

export default Account
